<span *ngIf="!badge">{{ name }}</span>
<span *ngIf="!!badge" class="badge bg-{{color}}">{{ name }}</span>
